var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewspaperOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 13.3333H3.33333C2.97971 13.3333 2.64057 13.1929 2.39052 12.9428C2.14048 12.6928 2 12.3536 2 12V4C2 3.64638 2.14048 3.30724 2.39052 3.05719C2.64057 2.80714 2.97971 2.66666 3.33333 2.66666H10C10.3536 2.66666 10.6928 2.80714 10.9428 3.05719C11.1929 3.30724 11.3333 3.64638 11.3333 4V4.66666M12.6667 13.3333C12.313 13.3333 11.9739 13.1929 11.7239 12.9428C11.4738 12.6928 11.3333 12.3536 11.3333 12V4.66666M12.6667 13.3333C13.0203 13.3333 13.3594 13.1929 13.6095 12.9428C13.8595 12.6928 14 12.3536 14 12V6C14 5.64638 13.8595 5.30724 13.6095 5.05719C13.3594 4.80714 13.0203 4.66666 12.6667 4.66666H11.3333M8.66667 2.66666H6M4.66667 10.6667H8.66667M4.66667 5.33333H8.66667V8H4.66667V5.33333Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewspaperOutline);
export default __webpack_public_path__ + "static/media/NewspaperOutline.c71e3495d14c4a671d3e8a3c9013f68b.svg";
export { ForwardRef as ReactComponent };